import type { ReactNode } from 'react';

import { Box, Typography, alpha } from '@mui/material';
import { CheckCircle2, InboxIcon } from 'lucide-react';

type DashboardEmptyStateProps = {
  message: string;
  action?: ReactNode;
  variant?: 'empty' | 'success';
};

const DashboardEmptyState = ({
  message,
  action,
  variant = 'empty',
}: DashboardEmptyStateProps) => {
  const isSuccess = variant === 'success';

  return (
    <Box
      sx={theme => ({
        px: 1.5,
        py: 1.25,
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        borderRadius: 2,
        backgroundColor: isSuccess
          ? alpha(theme.palette.success.main, 0.08)
          : alpha(theme.palette.primary.main, 0.08),
        color: isSuccess
          ? theme.palette.success.dark
          : theme.palette.primary.dark,
      })}
    >
      {isSuccess ? <CheckCircle2 size={18} /> : <InboxIcon size={18} />}
      <Typography variant="body2" sx={{ fontWeight: 500 }}>
        {message}
      </Typography>
      {action}
    </Box>
  );
};

export default DashboardEmptyState;
